module.exports = __webpack_public_path__ + "assets/img/W-4-F.fe44057d.png";